import { mapGetters, mapState } from 'vuex'
import { dynamicMapState } from '@/common/util/store'
import debugTestCards from '@/configuration/sources/TestCards.yml'
import { isArray, has } from 'underscore'

export const TestCardMixin = {
  computed: {
    ...dynamicMapState('context.namespace', ['testCard', 'selectedTestCard']),
    ...mapGetters(['isExtrasFormVisible', 'isApplePaySimulator']),
    ...mapState({
      isLegacyToolbar: state => state.toolbar.showLegacy,
      testBrand() {
        return this.isLegacyToolbar
          ? this.testCard?.split('.')[0]?.toUpperCase()
          : this.selectedTestCard?.brand
      },
      testCardConfiguration(state) {
        const brandConf =
          state.dna?.cards[this.testBrand] ||
          state.dna?.smartForm[this.testBrand]
        return brandConf?.fields[this.fieldName] || {}
      }
    }),
    shouldPrefillExtrasForm() {
      return this.isExtrasFormVisible && this.isApplePaySimulator
    }
  },
  watch: {
    selectedTestCard: {
      deep: true,
      handler(val) {
        if (val) this.changeValueTestCard()
      }
    },
    testCard(val) {
      if (val) this.changeValueTestCard()
    }
  },
  created() {
    if (this.shouldPrefillExtrasForm) this.changeValueTestCard()
  },
  methods: {
    changeValueTestCard() {
      let value = debugTestCards.fields[this.fieldName]
      // KJS-6311: Ignore this check for pocketType field, needs to bypass the hack for default value
      if (this.testCardConfiguration.value && this.fieldName !== 'pocketType')
        value = this.testCardConfiguration.value
      if (!this.testCardConfiguration.hidden && !this.isDisabled && value) {
        // Set the values
        if (
          this.fieldName === 'identityDocumentType' ||
          this.fieldName === 'pocketType'
        ) {
          this.selectedOption = this.getSelectId(value)
        } else if (
          'selectedOption' in this &&
          ~this.getOptionIndexWithId(value)
        ) {
          this.selectedOption = value
        } else if ('fieldValue' in this) {
          this.fieldValue = `${value}`
          this.onInput()
        }
      }
    },
    getSelectId(value) {
      const values = isArray(value) ? value : [value]
      for (const val of values)
        if (has(this.testCardConfiguration.values, val)) return val

      return this.selectedOption
    }
  }
}
